<template>
    <div class="container-fluid">
        <br>
        <div class="card card-outline card-outline-tabs" :class="appLayout.card">
            <div class="card-header p-0 border-bottom-0">
                <div class="nav-tabs-custom" role="tabpanel">
                    <!-- Nav tabs -->
                    <ul class="nav nav-tabs" role="tablist">
                        <li v-if="auth_user.ambiente == 'A'" class="nav-item">
                            <a href="#tabCertificado" class="nav-link" aria-controls="tabCertificado" role="tab"
                                data-toggle="pill" aria-selected="false">
                                <i class="fa fa-certificate"></i> Certificado Digital</a>
                        </li>
                        <li v-if="auth_user.ambiente == 'A'" class="nav-item">
                            <a href="#tabSMS" class="nav-link" aria-controls="tabSMS" role="tab" data-toggle="pill"
                                aria-selected="false">
                                <i class="fa fa-mobile"></i> SMS</a>
                        </li>
                        <li class="nav-item" v-if="allow('CONFIGURACOES')">
                            <a href="#tabPersonalizacao" class="nav-link active" aria-controls="tabPersonalizacao"
                                role="tab" data-toggle="pill" aria-selected="true">
                                <i class="fa fa-edit"></i> Personalização</a>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- Tab panes -->
            <div class="card-body" style="min-height:calc(100vh - 250px);">
                <div class="tab-content">
                    <div v-if="auth_user.ambiente == 'A'" role="tabpanel" class="tab-pane" id="tabCertificado">
                        <tab-certificado />
                    </div>
                    <div v-if="allow('CONFIGURACOES')" role="tabpanel" class="tab-pane active" id="tabPersonalizacao">
                        <tab-personalizacao />
                    </div>
                    <div v-else class="my-3">
                        <tab401>
                            <template v-slot:cargo class="my-3">Ative as permissões em: CONFIGURACOES > CARGOS > OPÇÕES
                                > EDITAR, e habilite CONFIGURACOES, Salve para confirmar as alterações. </template>
                        </tab401>
                    </div>
                    <div v-if="auth_user.ambiente == 'A'" role="tabpanel" class="tab-pane" id="tabSMS">
                        <tab-sms></tab-sms>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import TabCertificado from './components/tab-certificado.vue';
    import TabPersonalizacao from './components/tab-personalizacao.vue';
    import Tab401 from '../errors/401.vue';
    import TabSms from './components/tab-sms.vue';
    export default {
        components: {
            TabCertificado,
            TabPersonalizacao,
            Tab401,
            TabSms
        }
    }
</script>